<template>
  <div class="short-specification">
    <div class="short-specification__group">
      <table class="short-specification__specification">
        <tbody>
        <tr v-for="(item, index) in specification" :key="index"
            class="short-specification__specification-row">
          <td class="short-specification__specification-name-cell">
            <div class="short-specification__specification-name">
              <div class="short-specification__specification-name-text-wrapper">
                <span class="short-specification__specification-name-text">{{ index }}&#8199;</span>
              </div>
            </div>
          </td>
          <td class="short-specification__specification-value-cell">
            <span class="short-specification__specification-value">{{ item }}</span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="short-specification__group">
      <h4 class="short-specification__group-name">Важные характеристики</h4>
      <table class="short-specification__specification">
        <tbody>
        <tr v-for="(item) in properties.slice(0,4)" :key="item.id"
            class="short-specification__specification-row">
          <td class="short-specification__specification-name-cell">
            <div class="short-specification__specification-name">
              <div class="short-specification__specification-name-text-wrapper">
                <span class="short-specification__specification-name-text">{{item.name}}&#8199;</span>
              </div>
            </div>
          </td>
          <td class="short-specification__specification-value-cell">
            <span class="short-specification__specification-value">{{item.value}}</span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductShortSpecification",
  computed: {
    specification() {
      return this.$store.getters['product/GET_SPECIFICATION']
    },
    properties() {
      return this.$store.getters['product/GET_PROPERTIES']
    },
  },
}
</script>

<style scoped>

</style>